module.exports = __webpack_public_path__ + "media/assets/Clock-423cae001dfb5b543c7acffe1f874c65.svg";